(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('productSearch', {
        templateUrl: 'views/components/views/productSearch/productSearch.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'productSearchService', 'logisticService', 'ttGridFactory', 'rememberService', 'layoutService', function ($stateParams, stateService, utilityService, modalService, productSearchService, logisticService, ttGridFactory, rememberService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let onDestroy = [];
            let functionName = $stateParams.functionname;

            let variableNames = {
                businessco_no: '',
                stockplace_id: ''
            };

            vm.model = {
                functionName: functionName,
                gridReady: false,
                tabletSize: layoutService.getMediaQueries().tablet,
                bgPickType: {
                    selected: 'product',
                    buttons: [
                        { id: 'product', label: 'product', color: 'primary', onClick: () => vm.model.bgPickType.selected = 'product' },
                        { id: 'stock', label: 'stock', color: 'primary', onClick: () => vm.model.bgPickType.selected = 'stock' }
                    ]
                },
                productSearchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('productsearch_searchtext') },
                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('productsearch_searchtext') },
                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadItemListOrGrid() }
                ],
                setting: {},
                selectListCompanies: [],
                selectListStockPlaces: [],
                itemsListProducts: []
            };

            vm.grid = new ttGridFactory({
                rememberId: 'product_search_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setToolbar({ wrapping: true });

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await productSearchService.getSetting({
                    argtype: '-',
                    argvalue: '-'
                }))[0];
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }
            
            async function loadStockPlaces() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
                
                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
            }
            
            async function loadSearchProducts() {
                let fn = functionName;
                
                if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;
                if (fn === 'choice') fn = vm.model.bgPickType.selected;
                
                return vm.model.itemsListProducts = await productSearchService.listSearchProducts({
                    productsearch_searchtext: vm.model.setting.productsearch_searchtext,
                    functionname: fn,
                    stockplace_id: vm.model.setting.stockplace_id
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                let fn = functionName;

                if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;
                if (fn === 'choice') fn = vm.model.bgPickType.selected;

                vm.grid.dataTask.loadData = {
                    method: 3827,
                    parameters: {
                        productsearch_searchtext: vm.model.setting.productsearch_searchtext,
                        functionname: fn,
                        stockplace_id: vm.model.setting.stockplace_id
                    }
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region LOAD ITEM LIST OR GRID FUNCTION

            function loadItemListOrGrid() {
                if (vm.model.tabletSize.matches === true) {
                    loadGrid();
                } else {
                    loadSearchProducts();
                }
            }

            // #endregion LOAD ITEM LIST OR GRID FUNCTION

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                    	case 'businessco_no':
                        case 'stockplace_id':
                            variableNames[key] = 'stock' + '.' + key;
                    		break;
                    	default:
                    		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                    		break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no':
                    case 'stockplace_id':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }
            
            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS
            
            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'productsearch_searchtext':
                        vm.model.setting.productsearch_searchtext = '';

                        if (vm.model.tabletSize.matches === true) {
                            loadGrid();
                        } else {
                            vm.model.itemsListProducts = [];
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

            function openCalculator(id) {
                modalService.showCalculator(vm.model.setting[id]).then(function (value) {
                    vm.model.setting[id] = value;

                    if (vm.model.setting.productsearch_searchtext > '') loadItemListOrGrid();
                });
            }

            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

            vm.searchItems = function () {
                if (vm.model.setting.productsearch_searchtext > '') loadItemListOrGrid();
            };

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'productcreate':
                        go({
                            argtype: '-',
                            argvalue: '-'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgPickType = function (value) {
                vm.model.bgPickType.selected = value;
                
                if (vm.model.setting.productsearch_searchtext > '') loadItemListOrGrid();
            }

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        rememberFunc('businessco_no');
                        loadStockPlaces();
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                        vm.model.setting.stockplace_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                        rememberFunc('stockplace_id');

                        if (vm.model.setting.productsearch_searchtext > '') loadItemListOrGrid();
                        break;
                    case 'productsearch_searchtext':
                        if (utilityService.validateWatchValue(value, vm.model.setting.productsearch_searchtext) !== true) return;

                        vm.model.setting.productsearch_searchtext = value;

                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

                        if (vm.model.setting.productsearch_searchtext === '') {
                            vm.model.setting.productsearch_searchtext = '';
                            vm.model.itemsListProducts = [];
                        }
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON WINDOW RESIZE FUNCTION

            async function onWindowResize() {
                loadItemListOrGrid();
            }

            // #endregion ON WINDOW RESIZE FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                await loadSetting();
                loadCompanies();

                Promise.all([
                    loadStockPlaces()
                ]).then(() => {
                    loadItemListOrGrid();
                    Promise.resolve();
                });

            	window.addEventListener('resize', onWindowResize);
            	onWindowResize();
            }

            // #endregion ON INIT FUNCTION

            // #region DESTROY FUNCTION

            vm.$onDestroy = function () {
            	window.removeEventListener('resize', onWindowResize);

            	onDestroy.forEach((fn) => {
            		if (typeof fn === 'function') fn();
            	});
            }

            // #endregion DESTROY FUNCTION

        }]
    });
})();
